import React from 'react';

const EmsIcon = ({ width = 10, height = 10, color = 'black', ...rest }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 19 18" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g transform="scale(0.04142140832788315,0.03515625)">
        <path
          fill={color}
          d="m432.25,111.99L252.05,6.79c-14.1-8.2-31.4-8.2-45.5-.1L26.35,111.89c-13.9,8-22.4,22.8-22.4,38.9v210.4c0,16,8.6,30.9,22.4,38.9l180.3,105.2c14,8.1,31.4,8.1,45.4,0l180.3-105.2c13.9-8,22.4-22.8,22.4-38.9v-210.3c0-16-8.6-30.9-22.5-38.9ZM117.97,376.94l-38.97-22.5c-6.19-3.57-10-10.17-10-17.32v-45h40v33.45l28.97,16.73-20,34.64Zm-8.97-190.33v33.45h-40v-45c0-7.15,3.81-13.75,10-17.32l38.97-22.5,20,34.64-28.97,16.73Zm130.35,248.86c-3.09,1.79-6.55,2.68-10,2.68s-6.91-.89-10-2.68l-38.97-22.5,20-34.64,28.97,16.73,28.97-16.73,20,34.64-38.97,22.5Zm18.97-301.62l-28.97-16.73-28.97,16.73-20-34.64,38.97-22.5c6.19-3.57,13.81-3.57,20,0l38.97,22.5-20,34.64Zm131.38,203.27c0,7.15-3.81,13.75-10,17.32l-38.97,22.5-20-34.64,28.97-16.73v-33.45h40v45Zm0-117.06h-40v-33.45l-28.97-16.73,20-34.64,38.97,22.5c6.19,3.57,10,10.17,10,17.32v45Z"
        />
      </g>
    </svg>
  );
};

export default EmsIcon;
